import axios from "axios";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const Home = () => {
    const [id, setID] = useState("");
    const [pointencourage, setPointencourage] = useState(0);
    const [point12, setPoint12] = useState(0);
    const [pointprioritize, setPointprioritize] = useState(0);
    const navigate = useNavigate();

    const getResult = async (e) => {
        e.preventDefault();
        const time = toast.loading("Vui lòng chờ...");
        const searchUrl = `https://admission-result.somee.com/api/Crawl?id=${id}`;
        await axios.get(searchUrl).then((response) => {
            const result = response.data;
            if (result && result.length > 0) {
                toast.update(time, { render: "Đã xong", type: "success", isLoading: false, autoClose: 2000 });
                navigate("result", { state: { id, result, point12, pointencourage, pointprioritize } });
            }
            else
                toast.update(time, { render: "Không có dữ liệu", type: "error", isLoading: false, autoClose: 2000 });
        }).catch((error) => console.log(error));
    }

    return (
        <div className="container">
            <br />
            <h2>
                Tra Cứu Điểm Thi THPT năm 2024
            </h2>

            <form className="was-validated" onSubmit={getResult}>
                <div className="form-group">
                    <label htmlFor="point" className="mb-1">Số Báo Danh:</label>
                    <br />
                    <input
                        type="text"
                        className="form-control"
                        id="point"
                        placeholder="Nhập số báo danh"
                        name="point"
                        value={id}
                        onChange={e => setID(e.target.value)}
                        required={!id || id === ""} />
                    <div className="valid-feedback">Hợp lệ</div>
                    <div className="invalid-feedback">Vui lòng nhập đầy đủ</div>
                </div>
                {/* <br />
                <div className="form-group">
                    <label htmlFor="point">Điểm trung bình lớp 12 (vd: 8.1):</label>
                    <br />
                    <input
                        type="number"
                        step="0.01"
                        className="form-control"
                        id="point12"
                        placeholder="Nhập điểm trung bình lớp 12"
                        name="point12"
                        value={point12}
                        onChange={e => setPoint12(e.target.value)}
                        required
                    />
                    <div className="valid-feedback">Valid.</div>
                    <div className="invalid-feedback">Please fill out this field.</div>
                </div>
                <br />
                <div className="form-group">
                    <label htmlFor="point">Điểm ưu tiên (nếu có):</label>
                    <br />
                    <input
                        type="number"
                        step="0.01"
                        className="form-control"
                        id="pointprioritize"
                        value={pointprioritize}
                        placeholder="Nhập điểm ưu tiên"
                        name="pointprioritize"
                        onChange={e => setPointprioritize(e.target.value)}
                        required
                    />
                    <div className="valid-feedback">Valid.</div>
                    <div className="invalid-feedback">Please fill out this field.</div>
                </div>
                <br />
                <div className="form-group">
                    <label htmlFor="point">Điểm khuyến khích (nếu có):</label>
                    <br />
                    <input
                        type="number"
                        step="0.01"
                        className="form-control"
                        id="pointencourage"
                        value={pointencourage}
                        placeholder="Nhập điểm khuyến khích"
                        name="pointencourage"
                        onChange={e => setPointencourage(e.target.value)}
                        required
                    />
                    <div className="valid-feedback">Valid.</div>
                    <div className="invalid-feedback">Please fill out this field.</div>
                </div>
                <br />
                <div className="form-check">
                    <input type="radio" className="form-check-input" id="radioTHPT" name="optradio" value="THPT" checked />
                    <label className="form-check-label text-black" htmlFor="radio1">Bạn có phải là học sinh THPT hay không?</label>
                </div>
                <div className="form-check">
                    <input type="radio" className="form-check-input" id="radioGDTX" name="optradio" value="GDTX" />
                    <label className="form-check-label" htmlFor="radio1">Bạn có phải là học sinh GDTX hay không?</label>
                </div> */}
                <br />
                <button type="submit" className="btn btn-primary">Tra cứu điểm thi</button>
            </form>
            <br />
            <br />
            <div className="d-flex flex-row justify-content-around">
                <a href="https://zalo.me/g/xxpwxr794"><img src={require("../assets/images/2.jpg")} alt="zaloGroup" width="300" height="200" /></a>
                <a href="https://www.viendong.edu.vn/huong-dan-lam-thu-tuc-nhap-hoc-danh-cho-thi-sinh-2024.html"><img src={require("../assets/images/1.jpg")} alt="Cao đẳng Viễn Đông" width="300" height="200" /></a>
            </div>
        </div>
    )
}

export default Home;